import { Component } from 'react';
import LoadingComponent from './splitioLoading';

class WrapperComponent extends Component {
  render() {
    const { treatment, onComponent, offComponent, excludeRoleLevels, roleLevel, ...rest } = this.props;
    const excludedRoleLevel =
      typeof roleLevel !== 'undefined' &&
      roleLevel !== null &&
      typeof excludeRoleLevels !== 'undefined' &&
      excludeRoleLevels.includes(roleLevel);
    const RenderComponent =
      treatment === 'on' && !excludedRoleLevel
        ? onComponent
        : treatment === 'off' || excludedRoleLevel
        ? offComponent
        : LoadingComponent;
    return <RenderComponent {...rest} />;
  }
}

export default WrapperComponent;
